import { useEffect, useState, useRef } from 'react'
import { AnimatePresence } from 'framer-motion'
//css
import './App.css'
//redux
import { createStore, combineReducers } from 'redux'
import { Provider } from 'react-redux'
//reducres
import GallerieReducer from './reducers/GallerieReducer'
import SwipeReducer from './reducers/SwipeReducer'
import SkillsReducer from './reducers/SkillsReducer'
//components
import Sidenav from './components/Sidenav'
import Side0 from './components/Slide_0'
import Side1 from './components/Slide_1'
import Side2 from './components/Slide_2'
import Side3 from './components/Slide_3'
import Side4 from './components/Slide_4'
import Side5 from './components/Slide_5'

const rootReducer = combineReducers({
  GallerieReducer,
  SwipeReducer,
  SkillsReducer
})
const store = createStore(rootReducer)

const App = () => {
  const [heightState, setHeightState] = useState(0)
  const [railway, setRailway] = useState({counter:0, top:0})
  let slidesContainer = useRef(null)
  useEffect(() => {
    setHeightState(slidesContainer.current.clientHeight)
  })
  const updateRailWayCounter = z => {
    setRailway({...railway, counter:z, top: -heightState * z })
  }
  return(
       <Provider store={store}>
        <div className="app_main_container">  
          <div className="slides_container_parent">   
            <div className="railway_container" ref={slidesContainer}>
              <div className="railway" style={{top: railway.top}}>

                    <div className="slide" id="slide_0" style={{height: heightState}} >            
                     <Side0 counter={railway.counter}/>
                    </div>
                    
                    <div className="slide" id="slide_1" style={{height: heightState}} >
                      <Side1 counter={railway.counter}/>
                    </div>
                    
                    <div className="slide" id="slide_2" style={{height: heightState}} >
                      <Side2 counter={railway.counter}/>
                    </div>
                    
                    <div className="slide" id="slide_3" style={{height: heightState}} >
                      <Side3 counter={railway.counter}/>
                    </div>

                    <div className="slide" id="slide_3" style={{height: heightState}} >
                      <Side4 counter={railway.counter}/>
                    </div>

                    <div className="slide" id="slide_3" style={{height: heightState}} >
                      <Side5 counter={railway.counter}/>
                    </div>

              </div>
            </div>
          </div>  
          <Sidenav updateRailWayCounter={updateRailWayCounter} counter={railway.counter} />
        </div>
      </Provider>
    )
}

export default App